import gql from 'graphql-tag';

export const getPollingQuestionsWithAnswers = gql`
  query ($polling: Int) {
    getPollingQuestionsWithAnswers(polling: $polling) {
      pollingQuestionId
	    question
	    type
	    multipleChoice
	    choices
	    openText
	    maxRating
    }
  }
`
